import { Fragment } from "react";
import { Skeleton, Grid, FormControlLabel, Checkbox, Typography, Button, CircularProgress } from "@mui/material";

import { TextInput } from "../../../../../shared/ui/common/index.js";






/** Presentational section; state and actions remain owned by its parent. */
export default function CompanyDetailsTab({ TabPanel, value, loading, data, setData, submitEdit, loadingSumbit }) {
  return (
<TabPanel value={value} index={0}>
            {" "}
            {loading ? (
              <>
                <div className="grid grid-cols-4 gap-6">
                  {Array.from(Array(8).keys()).map((item, i) => (
                    <Fragment key={i + "TableCellLoading"}>
                      <Skeleton height={30} width="100%" />
                    </Fragment>
                  ))}
                </div>
              </>
            ) : (
              <>
                {" "}
                {data && (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label="نام شرکت / مجموعه"
                        currentValue={data?.companyName}
                        change={(e) => setData({ ...data, companyName: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" کد پستی"
                        currentValue={data?.postalCode}
                        change={(e) => setData({ ...data, postalCode: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label="تلفن  "
                        currentValue={data?.tel}
                        change={(e) => setData({ ...data, tel: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" کد اقتصادی"
                        currentValue={data?.economicCode}
                        change={(e) => setData({ ...data, economicCode: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label="  شناسه ثبت"
                        currentValue={data?.regNumber}
                        change={(e) => setData({ ...data, regNumber: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label="شهر "
                        currentValue={data?.city}
                        change={(e) => setData({ ...data, city: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label="شماره همراه "
                        currentValue={data?.contactMobile}
                        change={(e) => setData({ ...data, contactMobile: e })}
                      />
                    </Grid>{" "}
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" ایمیل "
                        currentValue={data?.companyEmail}
                        change={(e) => setData({ ...data, companyEmail: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <h2> - موارد دیگر</h2>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" توضیحات "
                        currentValue={data?.companyDescription}
                        change={(e) =>
                          setData({ ...data, companyDescription: e })
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" شعار "
                        currentValue={data?.companySlogan}
                        change={(e) => setData({ ...data, companySlogan: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <FormControlLabel
                        sx={{
                          border: (theme) =>
                            theme.palette.mode === "light"
                              ? "1px solid rgba(0, 0, 0, 0.23)"
                              : "1px solid rgba(55, 255, 255, 0.23)",
                          borderRadius: "4px",
                          height: "3.07rem",
                          marginLeft: "0px !important",
                          marginRight: "0px !important",
                          width: "100%",
                        }}
                        control={<Checkbox checked={Boolean(data?.LegalInvoice)} />}
                        onChange={(e) => {
                          setData({
                            ...data,
                            LegalInvoice: !data?.LegalInvoice,
                          });
                        }}
                        label={
                          <Typography
                            sx={{
                              color: (theme) =>
                                theme.palette.mode === "light"
                                  ? "rgba(0, 0, 0, 0.6)"
                                  : "rgba(255, 255, 255, 0.7)",
                              fontSize: { md: "0.75rem !important" },
                              fontWeight: "400 !important",
                            }}
                          >
                            درخواست فاکتور حقیقی
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextInput
                        label=" متن کپی رایت "
                        currentValue={data?.footerCopyright}
                        change={(e) => setData({ ...data, footerCopyright: e })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextInput
                        label=" آدرس"
                        currentValue={data?.address}
                        change={(e) => setData({ ...data, address: e })}
                      />
                    </Grid>{" "}
                    {/*      <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div className="flex gap-4">
                      {" "}
                      {data.logo && (
                        <img
                          src={`${baseUrl}/${DOWNLOAD_FILE}/${data.logo}`}
                          alt=""
                          loading="lazy"
                          className="object-contain"
                        />
                      )}
                      {userPermissions?.companyInfo?.update && (
                        <MultipleImages
                          files={files}
                          setFiles={setFiles}
                          selectedProductImage={selectedProductImage}
                          setselectedProductImage={setselectedProductImage}
                        />
                      )}
                    </div>
                  </Grid> */}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={submitEdit}
                        variant="contained"
                        disabled={loadingSumbit}
                        sx={{ width: { xs: "100%", sm: "auto" } }}
                      >
                        {loadingSumbit ? (
                          <CircularProgress />
                        ) : (
                          <>ثبت اطلاعات</>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </TabPanel>
  );
}
